import { AutoCloseLink, AutoCloseLinkProps } from '../AutoCloseLink';
import { CHECKOUT_URL } from '@/constants/env';
import { useMemo, useCallback } from 'react';

type TabPayLinkProps = {
  tabId: string;
  onComplete?: () => void;
} & Omit<AutoCloseLinkProps, 'onMessageCheck' | 'onComplete'>;

const getTabCheckoutUrl = (id: string) => {
  const url = new URL(CHECKOUT_URL);
  url.searchParams.append('tab_id', id);
  return url;
};

function TabPayLink({ tabId, onComplete, ...props }: TabPayLinkProps) {
  const url = useMemo<string>(
    () => getTabCheckoutUrl(tabId).toString(),
    [tabId]
  );

  const onMessageCheck = useCallback(
    (evt: MessageEvent) => evt.data.status === 'payment_completed',
    []
  );

  return (
    <AutoCloseLink
      onClose={onComplete}
      onMessageCheck={onMessageCheck}
      href={url}
      {...props}
    >
      Pay Tab
    </AutoCloseLink>
  );
}

export { TabPayLink };
